import { OrgAccountTypes, YesNoEmpty } from '@interfaces/models';
import { Action, createReducer, on } from '@ngrx/store';
import {
  ClearOrgState,
  UpdateOrgAccountTypeSelection,
  UpdateOrgAuthorityTypeSelection,
  UpdateOrgTriage,
} from '@store/actions/org/org.actions';

export interface OrgTriageState {
  accountType: OrgAccountTypes;
  authorityUpdate: YesNoEmpty;
}

export interface OrgState {
  triage: OrgTriageState;
}

const initialState: OrgState = {
  triage: {
    accountType: OrgAccountTypes.EMPTY,
    authorityUpdate: YesNoEmpty.EMPTY,
  },
};

const orgReducer = createReducer(
  initialState,
  on(ClearOrgState, () => initialState),
  on(UpdateOrgAccountTypeSelection, (state, { payload }) => ({
    ...state,
    triage: {
      ...state.triage,
      accountType: payload,
    },
  })),
  on(UpdateOrgAuthorityTypeSelection, (state, { payload }) => ({
    ...state,
    triage: {
      ...state.triage,
      authorityUpdate: payload,
    },
  })),
  on(UpdateOrgTriage, (state, { payload }) => ({
    ...state,
    triage: {
      ...state.triage,
      ...payload,
    },
  })),
);

export function reducer(state: OrgState | undefined, action: Action) {
  return orgReducer(state, action);
}
